import type { VoidFunctionComponent } from 'react';

import { FileType } from '../../../../shared/fileUpload';

import UploadComponentPage from './UploadComponentPage';

const BinaryUploadPage: VoidFunctionComponent = () => {
  return (
    <UploadComponentPage
      fileType={FileType.Binary}
    />
  );
};

export default BinaryUploadPage;
